<template>
    <div class="empty-state d-flex flex-column align-center justify-center text-center pa-8">
        <v-icon :icon="icon" size="64" class="empty-state__icon mb-4" />
        <div class="text-h6 mb-1">{{ title }}</div>
        <div v-if="text" class="empty-state__text text-body-2 text-medium-emphasis mb-4">
            {{ text }}
        </div>
        <div v-if="$slots.default" class="empty-state__actions">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
// Shared empty/zero-state used across lists, search results and management
// screens so a "nothing here yet" view always looks intentional (icon +
// message + optional call-to-action) instead of blank space or bare text.
type Props = {
    title: string;
    text?: string;
    icon?: string;
};

withDefaults(defineProps<Props>(), {
    text: "",
    icon: "mdi-inbox-outline",
});
</script>

<style lang="scss">
.empty-state {
    &__icon {
        color: rgba(var(--v-theme-on-surface), 0.38);
    }
    &__text {
        max-width: 32rem;
    }
}
</style>
